import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import CircleProgress from '@/components/circleProgress/circleProgress'
import { parseProducts } from '@/plugins/json_products_parser'
import moment from 'moment';

@Component({
  components: {
    CircleProgress
  }
})
export default class HistoryNotTerminalOrders extends Vue {
  @Prop({ default: () => { } }) createDate!: Function
  @Prop({ default: null }) order!: any
  @Prop({ default: false }) isTerminal: any
  @Prop({ default: false }) isLastOrder: any

  @Getter getCurrentOrder: any
  @Mutation CURRENT_ORDER: any
  @Getter getIsUnderMobile: any;
  @Getter getCountry
  @Getter getOpenCart: any

  roundRadius = 10
  roundPercent = 50
  roundDraw = 0
  strokeDasharray = ''
  isReady = false;
  currentOrder = null;

  percent = 5;
  statusIcon = ''

  created() {
    this.currentOrder = {...this.order};
  }

  mounted() {
    switch (this.order.status) {
      case 'order_not_generated':
        this.statusIcon = 'x'
        this.percent = 5
        break
      case 'waiting_restaurant_confirmation':
        this.statusIcon = 'good'
        this.percent = 10
        break
      case 'waiting_for_external_payment':
        this.statusIcon = 'cooking'
        this.percent = 45
        break
      case 'order_canceled_in_handoff':
        this.statusIcon = 'x'
        this.percent = 5
        break

      // -----

      case 'preparing_order':
        this.statusIcon = 'cooking'
        this.percent = 40
        break
      case 'order_canceled_by_restaurant':
        this.statusIcon = 'x'
        this.percent = 5
        break
      case 'troubleshooting_restaurant':
        this.statusIcon = 'x'
        this.percent = 5
        break
      case 'waiting_pickup_deliveryman':
        this.statusIcon = 'cooking'
        this.percent = 100
        break

      // -----

      case 'already_restaurant':
        this.statusIcon = 'x'
        this.percent = 20
        break
      case 'delivering_order':
        this.statusIcon = 'truck'
        this.percent = 76
        break
      case 'order_canceled_by_troubleshooting_delivery_man':
        this.statusIcon = 'x'
        this.percent = 5
        break
      case 'troubleshooting_deliveryman':
        this.statusIcon = 'x'
        this.percent = 50
        break
      case 'troubleshooting_hand_off':
        this.statusIcon = 'x'
        this.percent = 50
        break

      // -----

      case 'order_completed':
        this.statusIcon = 'target'
        this.percent = 100
        break
    }
    this.isReady = true;
  }

  get getParsedProducts() {
    const parsedProducts = parseProducts(this.currentOrder.json_products);
    return parsedProducts;
  }

  goToPay() {
    if (this.order.instance_currency === 'MXN') {
      window.open(`https://pay.conekta.com/link/${this.order.payment_link}`, '_blank');
    } else {
      window.open(`https://checkout.wompi.co/l/${this.order.payment_link}`, '_blank');
    }
  }

  _money(val) {
    const price = parseFloat(val)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }

  setOrder() {
    this.$emit('selectOrder', this.currentOrder);
  }

  get getIsTerminalStatus() {
    let response = false;
    if (this.order && this.order.status) {
      const status = this.order.status;
      response =
        status === "troubleshooting_restaurant" ||
        status === "order_not_generated" ||
        status === "order_canceled_by_restaurant" ||
        status === "order_canceled_in_handoff" ||
        status === "troubleshooting_hand_off";
    }
    return response;
  }

  get getIsFinished() {
    let response = false;
    if(this.order && this.order.status) {
      const status = this.order.status;
      response = status === "order_completed";
    }
    return response;
  }

  get getOrderStatusLabel() {
    let response = "";
    if(this.order && this.order.status) {
      const status = this.order.status;
      switch (status) {
        case "waiting_restaurant_confirmation":
          response = "Orden recibida";
          break;
        case "waiting_for_external_payment":
          response = "Esperando pago externo";
          break;
        case "preparing_order":
        case "waiting_pickup_deliveryman":
        case "already_restaurant":
          response = "Alistando";
          break;
        case "delivering_order" : 
          response = "En camino"
          break;
        case "troubleshooting_restaurant":
        case "order_canceled_by_restaurant":
          response = "Cancelada"
          break;
        case "order_completed": 
          response = "Entregada"
          break;
      }
    }
    return response;
  }

  get getOrderStatusColor() {
    let response = "";
    if(this.order && this.order.status) {
      const status = this.order.status;
      switch (status) {
        case "waiting_restaurant_confirmation":
          response = "#329ACF";
          break;
        case "waiting_for_external_payment":
          response = "#ffdf5f";
          break;
        case "preparing_order":
        case "waiting_pickup_deliveryman":
        case "already_restaurant":
          response = "#9BFB9A";
          break;
        case "delivering_order" : 
          response = "#9BFB9A"
          break;
        case "troubleshooting_restaurant":
        case "order_canceled_by_restaurant":
          response = "#CC0001"
          break;
        case "order_completed": 
          response = "#00F303"
          break;
      }
    }
    return response;
  }

  get getCreationDate() {
    let response = "";
    if(this.order && this.order.created_at) {
      response = moment(this.order.created_at).format('DD-MM-YYYY');
    }
    return response;
  }

  get getProgrammedFor() {
    let response = "";
    if(this.order && this.order.programmed_for) {
      response = moment(this.order.programmed_for).format('ddd DD [de] MMMM');
    }
    return response;
  }

  _truncate(value: string) {
    let response = value;
    let maxChars = 50;
    if(value && value.length && value.length > maxChars) {
      response = value.substr(0, maxChars) + "...";
    }
    return response;
  }
}
